import Joi from 'joi';
import {SlideShopFields} from './SlideShop.Constant';

export const VALIDATION_SLIDESHOP_CREATE = {
  options: {allowUnknownBody: false},
  body: {
    [SlideShopFields.productId]: Joi.string().required(),
    [SlideShopFields.productName]: Joi.string().required(),
    [SlideShopFields.slidePcs]: Joi.array().items(Joi.string()),
    [SlideShopFields.slideMobiles]: Joi.array().items(Joi.string()),
    [SlideShopFields.extraInfo]: Joi.object()
  }
};

export const VALIDATION_SLIDESHOP_UPDATE = {
  options: {allowUnknownBody: false},
  body: {
    [SlideShopFields.id]: Joi.string().required(),
    [SlideShopFields.productId]: Joi.string().required(),
    [SlideShopFields.productName]: Joi.string().required(),
    [SlideShopFields.slidePcs]: Joi.array().items(Joi.string()),
    [SlideShopFields.slideMobiles]: Joi.array().items(Joi.string()),
    [SlideShopFields.extraInfo]: Joi.object()
  }
};

export const VALIDATION_SLIDESHOP_DELETE = {
  options: {allowUnknownBody: false},
  body: {
    [SlideShopFields.id]: Joi.string().required(),
  }
};

export const VALIDATION_SLIDESHOP_LIST = {
  options: {allowUnknownBody: false},
  body: {

  }
};



// WEBPACK FOOTER //
// ./src/services/slideShop/SlideShop.Validator.js